module.exports = __webpack_public_path__ + "static/symphony5Waltz-1fdd8ae53959c5d65fc519df2de23eed.mp3";